"use strict";

angular.module("vendor")
.factory("CatalogBuyer", function($resource, FlashBag, $q, appConfig) {
    var catalogBuyerService = $resource(appConfig.API_SERVER + "/catalog/vendor/manage-authorized-customers/:id/", {
        id: "@id"
    }, {
        update: {
            method: "PUT"
        },
        delete: {
            method: "DELETE",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        }
    });
    return {
        get: function(id) {
            var params = {
                id: id
            };
            return catalogBuyerService.get(params,
                function(data) {
                },
                function errorCallback(response) {
                    FlashBag.apiError(response);
                }
            );

        },
        updateState: function(id, enabled) {
            var deferred = $q.defer();
            this.get(id).$promise.then(function onSuccess(data) {
                data.enabled = enabled;
                data.$update().then(deferred.resolve, deferred.reject);
            });
            return deferred.promise;
        },
        delete: function(id) {
            return catalogBuyerService.delete({id: id}).$promise;
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/catalog/catalog-buyer.factory.js
// module id = 879
// module chunks = 0